import styles from "./viewGames.module.css";

const viewGameStyles = {
  spinnerContainer: `w-full h-[200px] flex justify-center items-center`,
  outer_container: `flex flex-col w-full bg-liveGameBackground px-[20px] py-[25px] rounded-[10px] ${styles.outer_container}`,
  games_container: `flex flex-col gap-[8px] px-[15px] py-[10px] bg-themeColor rounded-[10px]`,
  header_section: `flex items-center w-full gap-2 justify-between`,
  header_container: `flex flex-col gap-2
                     md:flex-row
   ${styles.header_section}`,
  title: `text-[17px] font-Suisse font-[700] capitalize flex items-center ${styles.title}`,
  home_team_info: `flex items-center gap-[5px] self-center w-full justify-end mb-2
                   sm:gap-[6px] sm:self-end
                   md:hidden
  `,
  team_text: `text-[12px] font-[400] text-primaryHeading`,
  home_team_icon: `max-w-[24px] w-full h-auto`,
  team_name: `font-[400] text-[12px]
              sm:font-[500] sm:text-[16px] ${styles.team_name}`,
  filter_section: `flex sm:flex-row flex-col justify-end items-start sm:items-center py-1 px-3 gap-2 bg-themeColor rounded-[10px]
              md:items-center max-w-[500px] sm:ml-auto
            `,
  date_filters: `flex flex-col sm:flex-row items-start sm:items-center gap-1`,
  input_container: `flex items-center w-full relative`,
  label: `block text-[12px] `,
  apply_button: `bg-primaryHeading text-white rounded-[15px] px-3 py-1 focus:outline-none text-[14px] w-full
                  md:max-w-[unset] gap-2`,
  date_input: `px-1 bg-themeColor text-gray-600 uppercase block w-full rounded-md focus:border-none focus:ring-none text-[10px] outline-none 
                sm:text-[12px]`,
  divider: `w-[1px] h-[18px] bg-white mr-1 hidden sm:block`,
  buttonsContainer: `flex gap-2 w-full`,
  clear_button: `bg-primaryHeading text-white rounded-[15px] px-3 py-1 focus:outline-none text-[12px] max-w-[60px]`,
  dateFilterContainer: `w-full md:ml-auto md:max-w-[600px]`,
  match_info_section: `pb-2 ${styles.match_info_section}`,
  match_detail_container: `${styles.match_detail_container}`,
  headerRow: `flex justify-between font-[15px] font-[500] px-3 ${styles.headerRow}`,
  headerText: `flex-1 text-[15px] font-[500]`,
  time_div:`${styles.time_div}`,

  dataRow: `relative flex flex-col px-2 py-2 gap-[10px] pt-[8px] px-[15px] pb-[14px] rounded-[7px] w-[32%] ${styles.dataRow}`,
  detailCell: `flex text-center flex-row justify-between ${styles.detailCell}`,
  sportcomplex: `relative justify-between items-center ${styles.sportcomplex}`,
  
  location: `text-[15px] font-[400] text-ellipsis max-w-[100%] overflow-hidden whitespace-nowrap ${styles.location}`,
  date_and_time_container: `flex flex-row gap-[20px] items-center ${styles.date_and_time_container} `,
  date_and_time: `text-[13px] font-[400] ${styles.date_and_time}`,
  opponent_team_name: `text-[16px] font-[400] text-left ${styles.opponent_team_name}`,
  dataContainer: `flex flex-row flex-wrap gap-[20px] ${styles.dataContainer}`,
  noGamesContainer: `flex flex-col items-center justify-center w-full gap-2 py-10`,


  teams: `flex items-center gap-3 ${styles.teams}`,
  team_icon: `rounded-full ${styles.team_icon}`,
  vs: `px-2 text-[19px] font-[500] text-primaryHeading ${styles.vs}`,

  action_button_container: `flex items-center gap-[20px] ${styles.action_button_container}`,
  // vertical_divider: `w-[1px] h-[30px] max-md:w-full max-md:h-[1px] bg-white `,
  live_game_container: `flex items-center gap-2`,
  live_game_animation: `bg-liveGameText w-[8px] h-[8px] rounded-full animate-pulse ${styles.live_game_animation}`,
  liveButton: `text-liveGameText text-[15px] font-[500] cursor-pointer`,
  power_up_container: `flex items-center gap-2`,
  power_up_icon: `w-full h-auto max-w-[20px] ${styles.power_up_icon}`,
  deployButton: `text-[15px] font-[500] cursor-pointer ${styles.deployButton}`,
  power_up: `!rounded-[4px] ${styles.power_up}`,
  upcoming_text: `text-[14px] font-[400] ${styles.upcoming_text}`,
  score_game_container: `${styles.score_game_container}`,
  // score_game_icon: ` ${styles.score_game_icon}`,
  noGamesText: `text-[14px] font-[400]`,
};

export { viewGameStyles };
